module.exports = __webpack_public_path__ + "static/media/pool.312a6d1c.png";